import "./css/App.css";
import React from "react";
import { TimeBox } from "./TimeBox";

function App() {
  return (
    <div className="App">
      <TimeBox />
    </div>
  );
}

export default App;
